import { useState, useEffect } from "react";
import React from "react";
import { getData } from "../../API";
import { Link, useParams } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { parseISO, format, parse } from 'date-fns';



function ModuleReportView() {
 
  const formattedDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'MMMM d, yyyy');
  };
 
    useEffect(() => {
        AOS.init({
          
          once: false,     
        });
      }, []);
  let {id1,id2} = useParams();
  console.log("id1",id1);
  console.log("id2",id2);

  const [viewdata, setViewData] = useState([]);
  const [error, setError] = useState(null);

  console.log("viewdata",viewdata);

  const fetchData = async () => {
    try {

      // const res = await getData(`ParentGuid/GetSurveyByParentGuid?Sdid=${id1}&ParentGuid=${id2}`);
      const url = id2
        ? `ParentGuid/v2/GetSurveyByParentGuid?ParentGuid=${id2}`
        : `ParentGuid/v2/GetSurveyByParentGuid?Sdid=${id1}`;
      const res = await getData(url);

      // const response = await res.json();
      // console.log(response);
      setViewData(res);
     
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const aosAnimations = ['flip-left', 'fade-up','fade-up','fade-up','fade-up','fade-up','fade-up'];
  const aosDurations = [2000, 2000, 1000, 3500, 4000, 4500];
  return (
    <>
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="title_pages mb-0">Surveyor Report</h1>
            <Link to="/module_reports" className="btn btn-secondary"  style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
              <i className="fa-solid fa-arrow-left-long me-1"></i> Back
            </Link>
          </div>
        {
          viewdata.map((viewdata,index) => {
            const aosAnimation = aosAnimations[index % aosAnimations.length];
            const aosDuration = aosDurations[index % aosDurations.length];
            return (  <div
              className="card  "  data-aos={aosAnimation} data-aos-duration={aosDuration}
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              <div  className="card-body">
                <div className="row">
                  <React.Fragment key={viewdata.id}>

                     {id2&&<p style={{fontWeight:"600"}}><span style={{color:"#A7252B", fontWeight:"600"}} >"Tenent:" </span>{index+1}</p>}
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>Surveyor Name</label>
                      <p>
                        {viewdata.userName === null||viewdata.userName === "" ? "N/A" : viewdata.userName}
                      </p>
                    </div>
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Type of Establishment</label>
                        <p>
                          {viewdata.establishmentType === null||viewdata.establishmentType === ""
                            ? "N/A"
                            : viewdata.establishmentType}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Type of owner</label>
                        <p>
                          {viewdata.ownerShipType === null||viewdata.ownerShipType === ""
                            ? "N/A"
                            : viewdata.ownerShipType}
                        </p>
                      </div>
                    </div>
                    {/* <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Type of Property</label>
                        <p>
                          {viewdata.ownerShipType === null
                            ? "N/A"
                            : viewdata.ownerShipType}
                        </p>
                      </div>
                    </div> */}
                   
                    
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>Reference Id</label>
                      <p>
                        {viewdata.sdid === null||viewdata.sdid === "" ? "N/A" : viewdata.sdid}
                      </p>
                    </div>
                    <hr  />
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Property House No</label>
                        <p>
                          {viewdata.houseNo === null||viewdata.houseNo === ""
                            ? "N/A"
                            : viewdata.houseNo}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Owner Name</label>
                        <p>
                          {viewdata.ownerName === null||viewdata.ownerName === ""
                            ? "N/A"
                            : viewdata.ownerName}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Owner Contact No</label>
                        <p>
                          {viewdata.ownerContactNo === null||viewdata.ownerContactNo === ""
                            ? "N/A"
                            : viewdata.ownerContactNo}
                        </p>
                      </div>
                    </div>
                   
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>No Of Family Members </label>
                      <p>
                        {viewdata.noOfMembers === null||viewdata.noOfMembers === "" ? "N/A" : viewdata.noOfMembers}
                      </p>
                    </div>
                    <hr />
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Email Id</label>
                        <p>
                          {viewdata.emailId === null||viewdata.emailId === ""
                            ? "N/A"
                            : viewdata.emailId}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Latitude&Longitude</label>
                        <p>{viewdata.lat} , {viewdata.lng}</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Zone</label>
                        <p>
                          {viewdata.zoneName === null||viewdata.zoneName === ""
                            ? "N/A"
                            : viewdata.zoneName}
                        </p>
                      </div>
                    </div>
                    
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>Ward</label>
                      <p>
                        {viewdata.wardNo === null||viewdata.wardNo === "" ? "N/A" : viewdata.wardNo}
                      </p>
                    </div>
                    <hr />
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Category</label>
                        <p>
                          {viewdata.rateCategoryName === null||viewdata.rateCategoryName === ""
                            ? "N/A"
                            : viewdata.rateCategoryName}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Fixed Value</label>
                        <p>
                          {viewdata.fixedValue === null||viewdata.fixedValue === ""
                            ? "N/A"
                            : viewdata.fixedValue}
                        </p>
                      </div>
                    </div>
                    
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Rate</label>
                        <p>
                          {viewdata.rateType === null||viewdata.rateType === ""
                            ? "N/A"
                            : viewdata.rateType}
                        </p>
                      </div>
                    </div>
                    
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>Tenant Name</label>
                      <p>
                        {viewdata.tenantName === null||viewdata.tenantName === "" ? "N/A" : viewdata.tenantName}
                      </p>
                    </div>
                    <hr />
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Tenant Contact No</label>
                        <p>
                          {viewdata.tenantContactNo === null||viewdata.tenantContactNo === ""
                            ? "N/A"
                            : viewdata.tenantContactNo}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Commercial Room Attached</label>
                        <p>
                          {viewdata.isCommercialRoomAttached === null||viewdata.isCommercialRoomAttached === ""
                            ? "N/A"
                            :viewdata.isCommercialRoomAttached===true?"Yes":"No" }
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Min Waste Generation Qty</label>
                        <p>
                          {viewdata.minWasteQty === null||viewdata.minWasteQty === ""
                            ? "N/A"
                            : viewdata.minWasteQty}
                        </p>
                      </div>
                    </div>
                   
                    <div className="col-md-3 col-6 mb-3 card_details mb-3">
                      <label style={{color:"#A7252B", fontWeight:"600"}}>Registration Start Date</label>
                      <p>
                        {viewdata.registrationStartDate === null||viewdata.registrationStartDate === "" ? "N/A" : viewdata.registrationStartDate&&formattedDate( viewdata.registrationStartDate)}
                      </p>
                    </div>
                    <hr />
                    <div className="col-md-3 col-6 mb-3 card_details">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Registration End Date</label>
                        <p>
                        {viewdata.registrationEndDate === null||viewdata.registrationEndDate === "" ? "N/A" : viewdata.registrationEndDate&&formattedDate( viewdata.registrationEndDate)}
                          {" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Land Mark</label>
                        <p>
                          {viewdata.landmark === null||viewdata.landmark === "" ? "N/A" : viewdata.landmark}
                        </p>
                      </div>
                    </div>
  
                   
                    <div className="col-md-3 col-16 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Address</label>
                        <p >
                          {viewdata.address === null||viewdata.address === "" ? "N/A" : viewdata.address}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-16 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Service Status</label>
                        <p >
                          {viewdata.serviceStatusName === null||viewdata.serviceStatusName === "" ? "N/A" : viewdata.serviceStatusName}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 col-16 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Remarks</label>
                        <p>
                          {viewdata.remarks === null||viewdata.remarks === "" ? "N/A" : viewdata.remarks}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Photo</label>
  
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: "10px",
                          }}
                        >
                          <img
                            src={viewdata.imageUrl}
                            style={{
                              width: "auto",
  
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                            alt="Photo Not Available"
                          />
                        </div>
                        
                      </div>
                      
                    </div>
                    <div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Sub Category</label>
                        <p>
                          {viewdata.rateSubCategoryName === null||viewdata.rateSubCategoryName === ""
                            ? "N/A"
                            : viewdata.rateSubCategoryName}
                        </p>
                      </div>
                    </div>
                  
                   { viewdata.isCommercialRoomAttached&&<div className="col-md-3 col-6 mb-3">
                      <div className="card_details">
                        <label style={{color:"#A7252B", fontWeight:"600"}}>Municipal Reg No.</label>
                        <p>
                          {viewdata.muncipalRegNo === null||viewdata.muncipalRegNo === ""
                            ? "N/A"
                            : viewdata.muncipalRegNo}
                        </p>
                      </div>
                    </div>}
                  </React.Fragment>
  
                </div>
              </div>
            </div>);
            
          })
        }
        
        </div>
      </main>
    </>
  );
}

export default ModuleReportView;
